export default [
  {
    name: 'driverManagement',
    label: 'labels.driverManagement',
    permissionKey: 'driver_management',
    children: [
      {
        name: 'driver_add',
        label: 'labels.driverAdd',
        permissionKey: 'driver_add'
      },
      {
        name: 'driver_edit',
        label: 'labels.driverEdit',
        permissionKey: 'driver_edit'
      },
      {
        name: 'driver_delete',
        label: 'labels.driverDelete',
        permissionKey: 'driver_delete'
      },
      {
        name: 'driver_archive',
        label: 'labels.driverArchive',
        permissionKey: 'driver_archive'
      },
      // {
      //   name: 'driver_restore',
      //   label: 'labels.driverRestore',
      //   permissionKey: 'driver_restore'
      // },
      {
        name: 'driverDocumentManagement',
        label: 'labels.driverDocumentManagement',
        permissionKey: 'driver_document_management',
        children: [
          {
            name: 'driver_document_add',
            label: 'labels.driverDocumentAdd',
            permissionKey: 'driver_document_add'
          },
          {
            name: 'driver_document_edit',
            label: 'labels.driverDocumentEdit',
            permissionKey: 'driver_document_edit'
          },
          {
            name: 'driver_document_delete',
            label: 'labels.driverDocumentDelete',
            permissionKey: 'driver_document_delete'
          },
          {
            name: 'driver_document_archive',
            label: 'labels.driverDocumentArchive',
            permissionKey: 'driver_document_archive'
          }
          // {
          //   name: 'driver_document_restore',
          //   label: 'labels.driverDocumentRestore',
          //   permissionKey: 'driver_document_restore'
          // }
        ]
      },
      {
        name: 'driverLicenseManagement',
        label: 'labels.driverModule.license.management',
        permissionKey: 'driver_license_management',
        children: [
          {
            name: 'driver_license_add',
            label: 'labels.driverModule.license.add',
            permissionKey: 'driver_license_add'
          },
          {
            name: 'driver_license_edit',
            label: 'labels.driverModule.license.edit',
            permissionKey: 'driver_license_edit'
          },
          {
            name: 'driver_license_delete',
            label: 'labels.driverModule.license.delete',
            permissionKey: 'driver_license_delete'
          },
          {
            name: 'driver_license_archive',
            label: 'labels.driverModule.license.archive',
            permissionKey: 'driver_license_archive'
          }
          // {
          //   name: 'driver_license_restore',
          //   label: 'labels.driverModule.license.restore',
          //   permissionKey: 'driver_license_restore'
          // }
        ]
      }
    ]
  }
]
